import bootstrapNotify from '../../../../../modules/Gull/Framework/bootstrapNotify.js';
import datepicker from '../../../../../modules/Gull/Framework/datepicker.js';
import fileInput from '../../../../../modules/Gull/Framework/fileinput.js';
import formatters from '../../../../../modules/Gull/Framework/formatters.js';
import formValidation from '../../../../../modules/Gull/Framework/formValidation.js';
import httpRequest from '../../../../../modules/Gull/Framework/httpRequest.js';
import selectToggle from '../../../../../modules/Gull/Framework/selectToggle.js';
import selectValue from '../../../../../modules/Gull/Framework/selectValue.js';
import validation from '../../../../../modules/Gull/Framework/validation.js';

/**
 * ContentFunctions method object.
 *
 * Vult Cards en/of Modals in DOM met data retured door POSTrequest met payload contentDefinition en contentVars zoals geset in DOM (data-content-definition en data-content-vars attributes)
 * Zie lib/Dossier/default.yml en App/Werknemers/Dossier.php
 *
 * ContentDefinition opbouw: {'classname':{'functionTarget':{'functionName':'defaultOpen'}} 'classname' is de PHP Class (zie lib/Dossier/default.yml) en 'functionTarget' (bijv. 'card') en 'functionName' (bijv. 'listing') vormen samen de php functie naam (bijv. cardListing() ). Benodigde permissions zijn gedefinieerd in lib/Dossier/default.yml.
 *
 * - Card elementen worden onDomStateReady gevuld op basis van data retured door een POST request met als payload de defaultContentDefinition ([data-default-content-definition] attribute) geset in de DOM op het #content-wrapper element.
 * Bijv: Een defaultContentDefinition met {'beschikking':{'card':{'listing':true}},'betaling':{'card':{'listing':true}}} worden in de DOM de card Beschikking en de card Betaling gevuld met de data gereturned door de PHP functie cardListing in de Betaling en Beschikking PHP Class en zijn default opengeklapt.
 *
 * - Een click of change event getriggerd door een element met het attribute [data-content-function-modal] triggerd een Modal element in de DOM en vuld deze  met data geretured door een POST request als payload de contentDefinition en contentVars zoals geset in de DOM op het event.target element (data-content-definition en data-content-vars attributes)
 * Bijv : Een click event (bijv. een button click) -> triggerd HttpRequest.Send met de bijv. de payload: {"log":{"modal":{"add":true}}} -> Deze returned data waarmee een log toevoegen modal wordt geopend en gereturned door de PHP functie modalAdd() in de Log Class (zie lib/Dossier/default.yml)
 *
 *
 * @property {HTMLElement} targetElement - Het doelelement in de DOM die de aan te passen elementen bevat.
 * @property {Object} pageMethods - Aangepaste methods met betrekking tot de pagina eventueel gedefinieerd in de pagina specifieke js.
 * @property {string|null} contentId - Het ID van de van de betreffende content, wordt gedefinieerd in de DOM.
 * @property {string|null} defaultContentDefinition - De default content definition bij laden van de pagina.
 */

var contentFunctions = {

	targetElement: null,

	pageMethods: null,

	contentId: null,

	defaultContentDefinition: null,

	/**
	 * Initialiseerd de contentFunctions functies
	 *
	 *
	 * @param {string} targetElement - Het doelelement in de DOM die de aan te passen elementen bevat.
	 * @param {Object} [methods={}] - Aangepaste methods met betrekking tot de pagina eventueel gedefinieerd in de pagina specifieke js.
	 * @returns {void}
	 */
	init: function(targetElement = '#content-wrapper', methods = {}) {
		contentFunctions.pageMethods = methods;
		contentFunctions.targetElement = targetElement;
		contentFunctions.contentId = document.querySelectorAll(contentFunctions.targetElement)[0].getAttribute('data-content-id') || null;
		contentFunctions.defaultContentDefinition = document.querySelectorAll(contentFunctions.targetElement)[0].getAttribute('data-default-content-definition') || null;
		contentFunctions.getData();
		contentFunctions.initEvents();
	},

	/**
	 * Initeer DOM events
	 *
	 * @returns {string}
	 */
	initEvents: function() {

		/** Koppel openModal functie aan buttons met data-content-function-modal attribute */
		// TODO: title, contentDef en contentVars horen ws in losse functie
		document.addEventListener('click', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('a[data-content-function-modal], button[data-content-function-modal]')) {
					var title = target.getAttribute('data-content-title') || '';
					var contentDef = JSON.parse(target.getAttribute('data-content-definition'));
					var contentVars = JSON.parse(target.getAttribute('data-content-vars')) || {};
					contentFunctions.openModal(title, contentDef, contentVars);
					break;
				}
			}
		}, false);

		/** Koppel selectToggleModalContent functie aan selects met data-content-function-modal attribute */
		document.addEventListener('change', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('select[data-content-function-modal]')) {
					contentFunctions.selectToggleModalContent(target);
					break;
				}
			}
		}, false);

		/** Koppel saveModal functie aan submit events */
		// TODO: #generalModalContent niet gebruiken maar data attribute
		document.addEventListener('submit', function(event) {
			event.preventDefault();
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('body #generalModalContent form[data-validate]')) {
					contentFunctions.saveModal(event.target);
					break;
				}
			}
		}, false);

	},

	/**
	 * Opens a modal and populates it with content based on contentDefinition and contentVars.
	 *
	 * @param {string} title - De titel van de Modal
	 * @param {string} contentDef - De contentDefinition gebruikt voor de POST request in getData
	 * @param {Object} contentVars - De contentVars gebruikt voor de POST request in getData
	 * @returns {void}
	 */
	openModal: function(title, contentDef, contentVars) {

		/**
		 * Empty the general modal and set the title.
		 * @type {JQuery<HTMLElement>}
		 */
		var modal = $('#generalModal');
		modal.find('.modal-title').html(title);
		modal.find('.modal-body').html('');

		/**
		 * Retrieve the data and populate the modal when it's available.
		 */
		contentFunctions.getData(contentDef, contentVars);

	},

	/**
	 * Functie waarmee de data uit het formulier in de modal wordt opgeslagen en loading state wordt getriggerd
	 *
	 * @returns {string}
	 */
	saveModal: async function(form) {
		var validated = await validation.checkSubmitForm(form);
		if (validated) {
			contentFunctions.toggleSubmitButtonLoadingState(form, true);
			var contentDef = JSON.parse(form.getAttribute('data-content-definition'));
			var id = form.getAttribute('data-id');
			var reload = form.getAttribute('data-content-definition-reload');
			var fields = contentFunctions.parseFormFields(form);
			contentFunctions.saveData(contentDef, id, fields, reload, form);
		}
	},

	/**
	 * Functie waarmee de functionele loading state van het gesubmitte formulier in de DOM wordt ingeschakeld of uitgeschakeld.
	 *
	 * @param {object} form
	 * @param {bool} state
	 *
	 * @returns {string}
	 */
	toggleSubmitButtonLoadingState: function(form, state) {
		var submitButton = form.querySelectorAll('button[type=submit]')[0];
		var spinner = submitButton.querySelectorAll('span.spinner')[0];
		if (state) {
			submitButton.setAttribute('disabled', 'true');
			spinner.classList.remove('d-none');
		} else {
			submitButton.removeAttribute('disabled');
			spinner.classList.add('d-none');
		}
	},

	/**
	 * Functie waarmee de data wordt opgehaald
	 *
	 * @param {string} contentDef
	 * @param {object} vars
	 *
	 * @returns {string}
	 */
	selectToggleModalContent: function(target) {
		var title = target.getAttribute('data-content-title') || '';
		var group = target.closest('.form-group');
		var spinner = group.querySelector('[data-form-group-spinner]');
		var contentDef = JSON.parse(target.getAttribute('data-content-definition'));
		var contentVars = JSON.parse(target.getAttribute('data-content-vars')) || {};
		var name = target.getAttribute('name');
		contentVars[name] = target.options[target.selectedIndex].value;
		spinner.classList.remove('d-none');
		setTimeout(function() {
			contentFunctions.openModal(title, contentDef, contentVars);
		}, 10);
	},

	/**
	 * Functie waarmee de benodigde data, op basis van de contentDefinition en variables, wordt opgehaald met een HttpRequest
	 *
	 * @param {string} contentDef -
	 * @param {object} vars
	 *
	 * @returns {string}
	 */
	getData: function(contentDef = null, vars = null) {
		var postData = {
			types: contentDef || contentFunctions.defaultContentDefinition || '',
			vars: vars || []
		};
		httpRequest.send('POST', contentFunctions.getDataPath(), contentFunctions.parseData, contentFunctions.encodeFormData(postData));
	},

	/**
	 * Functie waarmee de data wordt opgeslagen op basis van de contentDefinition en de fields
	 *
	 * @param {string} contentDef - De contentdefinitie
	 * @param {string} id - Het id van het betreffende item (optioneel).
	 * @param {object} fields - De velden die opgeslagen moeten worden.
	 * @param {Array} reload - Een array van elementen die herladen moeten worden na opslaan (optioneel).
	 * @param {Element} form - Het formulierelement (optioneel).
	 *
	 * @returns {void}
	 */
	saveData: function(contentDef = null, id = '', fields = null, reload = [], form) {
		var postData = {
			id: id,
			fields: fields || [],
			reload: reload || [],
			save: contentDef || ''
		};
		httpRequest.send('POST', contentFunctions.getDataPath(), function(response) {
			response = JSON.parse(response);
			if (!response.success) {
				var report = response.report || 'Gegevens niet opgeslagen';
				bootstrapNotify('danger', '', report);
				contentFunctions.toggleSubmitButtonLoadingState(form, false);
			} else {
				bootstrapNotify('success', '', 'Gegevens opgeslagen');
				$('.modal').modal('hide');
				if (response.action.gotoUrl !== '') {
					window.location.href = response.action.gotoUrl;
				} else if (response.action.reloadPage) {
					window.location.reload(false);
				} else {
					contentFunctions.getData(response.action.reloadContent);
				}
			}
		}, contentFunctions.encodeFormData(postData));

	},

	/**
	 * Voer voor elke class/functie, geset in de data, de ModalContent of CardContent functie uit om de inhoud van deze te setten
	 *
	 * Bijvoorbeeld: {"log":{"modal":{"add":"<div>Voorbeeld</div>"}}} - Vult modal body met '<div>Voorbeeld</div>' en opent modal)
	 * Bijvoorbeeld: {"actie":{"card":{"listing":{"heading":"<div>Voorbeeld</div>","body":"<div>Voorbeeld</div>"}}}} - Vult card head met '<div>Voorbeeld</div>' en body met '<div>Voorbeeld</div>')
	 *
	 * @param {object} data
	 *
	 * @returns {string}
	 */
	parseData: function(data) {
		var dataJSON = JSON.parse(data);
		var functionName;
		for (let [classname, functions] of Object.entries(dataJSON)) {
			for (let [target, contents] of Object.entries(functions)) {
				for (let [name, content] of Object.entries(contents)) {
					functionName = 'setContent' + formatters.upperCaseFirst(classname) + formatters.upperCaseFirst(target) + formatters.upperCaseFirst(name);
					if (typeof contentFunctions.pageMethods[functionName] === 'function') {
						contentFunctions.pageMethods[functionName](content);
					} else {
						if (target == 'modal') {
							contentFunctions.setModalContent(content);
						} else {
							contentFunctions.setCardContent(classname, target, name, content);
						}
					}
				}
			}
		}
	},

	/**
	 * Vul in de DOM een modal element met de geladen inhoud
	 *
	 * @param {string} content
	 *
	 * @returns {string}
	 */
	setModalContent: function(content) {

		/** Vul en open de modal */
		var modal = $('#generalModal');
		modal.find('.modal-body').html(content);
		modal.modal('show');
		modal.on('shown.bs.modal', function() {
			modal.find('.form-group:first-of-type [data-focus]').focus();
		});

		/** Initieer de benodigde functies voor de formulieren */
		var form = modal.find('.modal-body form');
		selectValue.init(form);
		selectToggle.init(form);
		datepicker.init(form);
		fileInput.initFilepond(modal[0]);
		formValidation.initBlurEvent(modal[0]);

	},

	/**
	 * Vul in de DOM een Card element met de geladen inhoud, bestaande uit een Heading en een Body van de card
	 *
	 * @param {string} classname
	 * @param {string} target
	 * @param {string} name
	 * @param {string} content
	 *
	 * @returns {string}
	 */
	setCardContent: function(classname, target, name, content) {

		var cardHeading = document.querySelectorAll('[data-content-slug=' + (classname + '-' + target + '-' + name) + '] [data-card-content-heading]');
		if (typeof cardHeading[0] !== 'undefined') {
			$(cardHeading).html(content.heading);
		}

		var cardBody = document.querySelectorAll('[data-content-slug=' + (classname + '-' + target + '-' + name) + '] [data-card-content-body]');
		if (typeof cardBody[0] !== 'undefined') {
			$(cardBody).fadeOut(200, function() {
				$(cardBody).html(content.body);
				$(cardBody).fadeIn(200);
			});
		}

	},

	/**
	 * Verwerk de velden in form voor submit
	 *
	 * @param {object} form
	 *
	 * @returns {object}
	 */
	parseFormFields: function(form) {
		var obj = {};
		$.each($(form).serializeArray(), function(i, o) {
			var n = o.name,
				v = o.value;
			obj[n] = obj[n] === undefined ? v :
				$.isArray(obj[n]) ? obj[n].concat(v) : [obj[n], v];
		});
		return obj;
	},

	/**
	 * Encode data voor submit
	 *
	 * @param {object} data
	 *
	 * @returns {string}
	 */
	encodeFormData: function(data) {
		var formData = new FormData();
		for (let [index, value] of Object.entries(data)) {
			if (typeof value == 'object') {
				value = JSON.stringify(value);
			}
			formData.append(index, value);
		}
		return formData;
	},

	/**
	 * Verkrijg data path op basis van content id en ajax url
	 *
	 * @returns {string}s
	 */
	getDataPath: function() {
		return window.app.ajaxPath + 'content/';
	}

};

export default contentFunctions;
